<div class="id-cards-wrapper">
    <mapfre-card [singleCard]="false" [additionalClasses]="'billing-new-container'">        
        <div *ngIf="policyDetails?.length">
            <app-id-cards [policies]="policyDetails" [displayIDCardHeader]="'true'" ></app-id-cards>
        </div>    
    </mapfre-card>
</div>